import { useEffect, useRef, useState } from "react";

export const useMeasuredElementHeight = <T extends HTMLElement>() => {
  const [heightPx, setHeightPx] = useState(0);
  const resizeObserverRef = useRef<ResizeObserver | null>(null);

  const ref = (element: T | null) => {
    resizeObserverRef.current?.disconnect();
    resizeObserverRef.current = null;

    if (!element) {
      setHeightPx(0);
      return;
    }

    const updateHeight = () => {
      const nextHeight = Math.ceil(element.getBoundingClientRect().height);
      setHeightPx((previousHeight) =>
        previousHeight === nextHeight ? previousHeight : nextHeight
      );
    };

    updateHeight();

    const observer = new ResizeObserver(updateHeight);
    observer.observe(element);
    resizeObserverRef.current = observer;
  };

  useEffect(() => {
    return () => {
      resizeObserverRef.current?.disconnect();
    };
  }, []);

  return { heightPx, ref };
};
